import React from "react";
import EmptyView from "@view/EmptyView";

export type DocumentSelectionActionPhase = "hidden" | "visible";

type DocumentSelectionItemPanelProps = {
  actionPhase: DocumentSelectionActionPhase;
  actionView: React.ReactElement;
};

const DocumentSelectionItemPanel: React.FC<DocumentSelectionItemPanelProps> = ({
  actionPhase,
  actionView,
}) => {
  const render = {
    hidden: <EmptyView />,
    visible: actionView,
  } as const satisfies Record<DocumentSelectionActionPhase, React.ReactElement>;

  return render[actionPhase];
};

export default DocumentSelectionItemPanel;
